import { combineReducers } from 'redux'
import constructionsReducer from './constructions'
import applicationReducer from './application'
import doorPreviewReducer from './door_preview'
import orderReducer from './order'
import partsReducer from './parts'
import orderCallReducer from './order_call'
import { pendingTasksReducer } from 'react-redux-spinner';

const reducers = combineReducers({
  pendingTasks: pendingTasksReducer,
  constructionsState: constructionsReducer,
  doorPreviewState: doorPreviewReducer,
  orderState: orderReducer,
  applicationState: applicationReducer,
  partsState: partsReducer,
  orderCall: orderCallReducer,
});

export default reducers;



// WEBPACK FOOTER //
// ./app/javascript/app/reducers/index.js